import type { ComboDefinition } from '../domain/types';

/**
 * Provisional combo multipliers from the game design document.
 * Eligibility adapts to unlocked dice count; overlap/tie-break rules remain open.
 */
export const COMBO_DEFINITIONS: readonly ComboDefinition[] = [
  {
    id: 'six_of_a_kind',
    name: 'Six of a Kind',
    multiplier: 25,
    pattern: [6],
  },
  {
    id: 'perfect_straight',
    name: 'Perfect Straight',
    multiplier: 15,
    pattern: [1, 1, 1, 1, 1, 1],
    perfectStraight: true,
  },
  {
    id: 'five_of_a_kind',
    name: 'Five of a Kind',
    multiplier: 12,
    pattern: [5],
  },
  {
    id: 'four_plus_two',
    name: 'Four plus Two',
    multiplier: 11,
    pattern: [4, 2],
  },
  {
    id: 'double_triples',
    name: 'Double Triples',
    multiplier: 10,
    pattern: [3, 3],
  },
  {
    id: 'four_of_a_kind',
    name: 'Four of a Kind',
    multiplier: 7,
    pattern: [4],
  },
  {
    id: 'full_house',
    name: 'Full House',
    multiplier: 5,
    pattern: [3, 2],
  },
  {
    id: 'three_pairs',
    name: 'Three Pairs',
    multiplier: 4,
    pattern: [2, 2, 2],
  },
  {
    id: 'three_of_a_kind',
    name: 'Three of a Kind',
    multiplier: 3,
    pattern: [3],
  },
  {
    id: 'two_pairs',
    name: 'Two Pairs',
    multiplier: 2,
    pattern: [2, 2],
  },
  {
    id: 'one_pair',
    name: 'One Pair',
    multiplier: 1.5,
    pattern: [2],
  },
  {
    id: 'baseline',
    name: 'Basic Attack',
    multiplier: 1,
    pattern: [],
  },
] as const;
